import React from 'react'
import { Label as AriaLabel, LabelProps } from 'react-aria-components'

import './Label.css'

export interface Props extends LabelProps {}

export function Label({ children, ...props }: Props) {
  return <AriaLabel {...props}>{children}</AriaLabel>
}
